var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          {
            staticClass:
              "grey-black bold px-sm-5 px-3 mt-4 d-flex flex-row align-items-center",
          },
          [
            _c("b-skeleton", {
              staticClass: "mb-0",
              attrs: { width: "13rem" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "ml-2",
              attrs: { type: "avatar", width: "1.5rem", height: "1.5rem" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "justified grey-text text-darken-1 px-sm-5 px-3 mt-3",
          },
          [_c("b-skeleton", { attrs: { width: "80%" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pb-5 px-sm-5 px-3 d-flex flex-row align-items-center",
          },
          [
            _c("b-skeleton", { staticClass: "mb-0", attrs: { width: "8rem" } }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "ml-2",
              attrs: { type: "avatar", width: "1rem", height: "1rem" },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "div",
          {
            staticClass:
              "grey-black bold px-sm-5 px-3 mt-4 d-flex flex-row align-items-center",
          },
          [
            _c("b-skeleton", {
              staticClass: "mb-0",
              attrs: { width: "13rem" },
            }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "ml-2",
              attrs: { type: "avatar", width: "1.5rem", height: "1.5rem" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "justified grey-text text-darken-1 px-sm-5 px-3 mt-3",
          },
          [_c("b-skeleton", { attrs: { width: "80%" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "pb-5 px-sm-5 px-3 d-flex flex-row align-items-center",
          },
          [
            _c("b-skeleton", { staticClass: "mb-0", attrs: { width: "8rem" } }),
            _vm._v(" "),
            _c("b-skeleton", {
              staticClass: "ml-2",
              attrs: { type: "avatar", width: "1rem", height: "1rem" },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }